import { authForgotPasswordMutation } from '$api-client/@tanstack/react-query.gen'
import { DisplayLabel } from '$components'
import { ToastHelper } from '$components'
import { useAuth } from '$features/auth/hooks/use-auth'
import { TabLayout } from '$features/settings/layouts/tab'
import { SettingsRoutePath } from '$features/settings/routes/protected'
import { Breadcrumb, Text, Button, Divider } from '$components'
import { SettingsIcon } from '$components'
import { useMutation } from '@tanstack/react-query'
import { usePageTitle } from '$components'

export function ProfileTab() {
  usePageTitle('Settings - Profile')
  const { user } = useAuth()

  const { mutate: sendResetEmail, isPending } = useMutation({
    ...authForgotPasswordMutation(),
    onSuccess: () => ToastHelper.success('Password reset email sent successfully.'),
    onError: () => ToastHelper.error('Failed to send password reset email.'),
  })

  const handleChangePassword = () => {
    sendResetEmail({
      body: {
        email: user.email,
      },
    })
  }

  return (
    <TabLayout>
      <Breadcrumb
        items={[
          {
            label: 'Settings',
            icon: SettingsIcon,
            path: SettingsRoutePath.Settings,
          },
          {
            label: 'Profile',
            path: SettingsRoutePath.SettingsProfile,
          },
        ]}
      />

      <div>
        <Text
          type="h2"
          weight="medium"
        >
          Profile Settings
        </Text>

        <Text
          type="s"
          className="text-gray-500 mt-1"
        >
          View your profile information and manage security settings.
        </Text>
      </div>

      <div className="flex flex-col gap-4">
        <Text
          type="h3"
          weight="medium"
        >
          Account Details
        </Text>

        <div>
          <DisplayLabel>First Name</DisplayLabel>
          <Text type="s">
            {user.first_name}
          </Text>
        </div>

        <div>
          <DisplayLabel>Last Name</DisplayLabel>
          <Text type="s">
            {user.last_name}
          </Text>
        </div>

        <div>
          <DisplayLabel>Email</DisplayLabel>
          <Text type="s">
            {user.email}
          </Text>
        </div>
      </div>

      <Divider />

      <div className="flex flex-col gap-4">
        <Text
          type="h3"
          weight="medium"
        >
          Permissions
        </Text>

        <div>
          <DisplayLabel>Role</DisplayLabel>
          <Text type="s">
            { user.role }
          </Text>
        </div>
      </div>

      <Divider />

      <div className="flex flex-col gap-4">
        <Text
          type="h3"
          weight="medium"
        >
          Security
        </Text>

        <div className="flex flex-col gap-2">
          <Text
            type="s"
            className="text-gray-600"
          >
            Click the button below to reset your password. You will receive an email with instructions to set a new password.
          </Text>

          <div className="mt-2">
            <Button
              variant="secondary"
              disabled={isPending}
              onClick={handleChangePassword}
            >
              Change Password
            </Button>
          </div>
        </div>
      </div>
    </TabLayout >
  )
}
